import React, { Component } from "react";
import { View, Image, Text, StyleSheet } from "react-native";
import { agentConnection } from "../../services/socket/operator-service";
import operatorHomeStyle from "../../styles/operatorHomeStyle";

class CustomersConnected extends Component {
  constructor(props) {
    super(props);
    this.state = {
      askingToConnect: false,
    };
  }

  //on chat selection
  onSelectChat = (item) => {
    this.props.onSelectChat(item);
  };

  //on connect button click
  onClickButton = async (item) => {
    await this.onSelectChat(item);
    if (!this.props.AllDetailsRooms[item].isAgentConnectedToCustomer) {
      //on connecting to customer
      agentConnection(true, item);
    }
  };

  //render users list in side nav
  renderUsersConnected = (AllDetailsRooms) => {
    //sort on latest first
    const allkeys = Object.keys(AllDetailsRooms).sort((a, b) =>
      new Date(AllDetailsRooms[a].createdAt) <
        new Date(AllDetailsRooms[b].createdAt)
        ? 1
        : new Date(AllDetailsRooms[b].createdAt) <
          new Date(AllDetailsRooms[a].createdAt)
          ? -1
          : 0
    );

    return allkeys.map((item, index) => {
      return (
        <View
          key={`customers${index}`}
          nativeID={`customers${index}`}
          style={[
            operatorHomeStyle.viewEachRoom,
            item === this.props.room ? operatorHomeStyle.backGroundChat : null,
          ]}
        >
          <Image
            style={operatorHomeStyle.IconRoomsImage}
            source={require("../../../assets/images/botavatar.png")}
          />
          <View>
            <Text
              style={operatorHomeStyle.txtRoomName}
              onPress={() => this.onSelectChat(item)}
            >
              {AllDetailsRooms[item].customerName
                ? AllDetailsRooms[item].customerName
                : item.substring(0, 20) + (item.length > 20 ? "..." : "")}
            </Text>
            <View style={operatorHomeStyle.row}>
              <button
                style={{
                  width: 90,
                  height: 20,
                  color: "black",
                  fontFamily: "SFProText",
                  fontSize: 12,
                  marginLeft: 10,
                  marginTop: 3,
                  cursor: "pointer",
                  textAlign: "center",
                  backgroundColor:
                    AllDetailsRooms[item].isAgentConnectedToCustomer === 1
                      ? "green"
                      : AllDetailsRooms[item].isAgentHandOff === 1
                        ? "rgb(226, 112, 75)"
                        : "grey",
                  border: "none",
                }}
                disabled={
                  AllDetailsRooms[item].isAgentConnectedToCustomer ||
                  !AllDetailsRooms[item].isAgentHandOff
                }
                onClick={() => this.onClickButton(item)}
              >
                {AllDetailsRooms[item].isAgentConnectedToCustomer === 1
                  ? "Connected"
                  : AllDetailsRooms[item].isAgentHandOff === 1
                    ? "Connect"
                    : "Disconnected"}
              </button>
              {AllDetailsRooms[item].isAgentConnectedToCustomer === 1 && (
                <button
                  style={{
                    width: 90,
                    height: 20,
                    color: "black",
                    fontFamily: "SFProText",
                    marginLeft: 10,
                    marginTop: 3,
                    cursor: "pointer",
                    textAlign: "center",
                    border: "none",
                    fontSize: 12,
                  }}
                  onClick={() => agentConnection(false, item)}
                >
                  {"Disconnect"}
                </button>
              )}
            </View>
          </View>
        </View>
      );
    });
  };

  //render ui
  render() {
    return (
      <View style={{ width: 300 }}>
        {this.renderUsersConnected(this.props.AllDetailsRooms)}
      </View>
    );
  }
}
export default CustomersConnected;
